<template>
  <!-- Nuxt要求layout必须是单根元素 -->
  <div id="basic-layout">
    <GlobalNav id="header"/>

    <div id="main">
      <slot></slot>
    </div>

    <!-- 宽屏状态下 网页底部栏 -->
    <GlobalFooter/>
  </div>
</template>

<script lang="ts" setup>
import GlobalNav from '@/components/GlobalNav.vue'
import GlobalFooter from '@/components/GlobalFooter.vue'
</script>

<style scoped>

#basic-layout {
  display: flex;
  flex-direction: column;

  min-width: 1280px;
  margin: 0 auto;
}

#header {
  background: linear-gradient(180deg, #e8e8fe 0%, #e7f2fa 100%);
  color: #333333;
  margin-bottom: 80px;
}

#main {
  background-color: #fff;
}
</style>
